import {Image} from "react-bootstrap";
import * as React from "react";

function Section({src, title, subtitle, paragraphs, reversed}) {


    return (
        <div className="d-flex flex-row align-items-lg-start gap-xxl-5 mb-lg-5">
            {reversed && <Image
                className="section-image"
                src={src}
            />}
            <div className="section-text-area d-flex flex-column gap-3">
                <h4>{title}</h4>
                <h5>{subtitle}</h5>
                <div>
                    {paragraphs.map((paragraph, index) => (<p key={index}>{paragraph}</p>))}
                </div>
            </div>
            {!reversed && <Image
                className="section-image"
                src={src}
            />}
        </div>
    )
}

export default Section;